import { objectToFormData } from "../../../../../api/utils";
import axiosInstance from "../../../../../utils/axios";

export function ticketMessageInput(value, setValue) {
  value = value.replace(/<h1>/g, '<b>').replace(/<\/h1>/g, '</b>');
  value = value.replace(/<h2>/g, '<b>').replace(/<\/h2>/g, '</b>');
  value = value.replace(/<h3>/g, '<b>').replace(/<\/h3>/g, '</b>');
  value = value.replace(/<h4>/g, '<b>').replace(/<\/h4>/g, '</b>');
  value = value.replace(/<h5>/g, '<b>').replace(/<\/h5>/g, '</b>');
  value = value.replace(/<h6>/g, '<b>').replace(/<\/h6>/g, '</b>');
  setValue(value);
}

export function ticketMessageSubmitHtmlFormatter(html) {
  const pattern = /<p><br><\/p>$/i;
  while (pattern.test(html)) html = html.replace(pattern, '');
  return html;
}

export async function ticketMessageSubmitAllPictures(html) {
  if (!html.includes('<img src=')) return html;
  const imgSrcRegex = /<img src="([^"]*)"/g;
  const imgSrcMatch = html.matchAll(imgSrcRegex);
  const imgSrcArray = Array.from(imgSrcMatch, (match) => match[1]).filter(img => img && !img.includes('//res.cloudinary.com/agoraserv') && !img.includes('emoji') );
  await axiosInstance.post("/AddTicketImages", objectToFormData({ pictures: imgSrcArray }))
    .then(res => {
      if (res.data) {
        res.data.forEach(picKeyValue => {
          if (picKeyValue.key && picKeyValue.value) html = html.replace(picKeyValue.key, picKeyValue.value);
        })
      }
    }).catch(() => {/* no error message just use original pic */ });
  return html;
}